/** Columns A–F */
export type Col = 'A' | 'B' | 'C' | 'D' | 'E' | 'F'

/** Rows 1–6 */
export type Row = 1 | 2 | 3 | 4 | 5 | 6

/** A coordinate on the 6×6 grid, e.g. { col: 'A', row: 1 } */
export interface Coord {
  col: Col
  row: Row
}

/** Direction for ship placement and torpedo firing */
export type Direction = 'horizontal' | 'vertical'

/** The state of a single cell as seen by a player */
export type CellState = 'unknown' | 'miss' | 'hit' | 'sunk'

/** All valid columns in order */
export const COLS: Col[] = ['A', 'B', 'C', 'D', 'E', 'F']

/** All valid rows in order */
export const ROWS: Row[] = [1, 2, 3, 4, 5, 6]

/** Number of columns / rows */
export const GRID_SIZE = 6

/** Convert column letter to 0-based index */
export function colIndex(col: Col): number {
  return col.charCodeAt(0) - 'A'.charCodeAt(0)
}

/** Convert 0-based index to column letter */
export function indexToCol(i: number): Col {
  return String.fromCharCode('A'.charCodeAt(0) + i) as Col
}

/** Create a coordinate key string for maps/sets, e.g. "A1" */
export function coordKey(coord: Coord): string {
  return `${coord.col}${coord.row}`
}

/** Check if a coordinate is within the grid */
export function isValidCoord(coord: Coord): boolean {
  return COLS.includes(coord.col) && ROWS.includes(coord.row)
}
